import { useSession } from "@/lib/auth/auth";
import { getUserAccountingFirmRole } from "@/lib/users/user-roles";
import Intercom, { shutdown, update } from "@intercom/messenger-js-sdk";
import { useMatches } from "@tanstack/react-router";
import posthog from "posthog-js";
import { useEffect, useRef } from "react";

export function AnalyticsIdentification() {
  const { data: session } = useSession();
  const matches = useMatches();
  const lastIdentifiedRef = useRef<string | null>(null);

  const companyMatch = matches.find(
    (match) => match.routeId === "/_authenticated/$company",
  );
  const company = companyMatch?.context?.company as
    | { companyName?: string; companySlug?: string }
    | undefined;

  useEffect(() => {
    const user = session?.user;

    if (!user?.userId) {
      if (lastIdentifiedRef.current) {
        posthog.reset();
        shutdown();
        Intercom({
          app_id: import.meta.env.VITE_INTERCOM_APP_ID as string,
          hide_default_launcher: true,
          language_override: "de",
        });
        lastIdentifiedRef.current = null;
      }
      return;
    }

    const identityKey = `${user.userId}-${company?.companySlug ?? "no-company"}`;
    if (lastIdentifiedRef.current === identityKey) {
      return;
    }

    posthog.identify(user.userId, {
      email: user.email,
      userId: user.userId,
      name: user.name,
      role: getUserAccountingFirmRole(user),
      type: user.systemRole,
      company: company?.companyName,
    });

    update({
      user_id: user.userId,
      email: user.email,
      name: user.name,
    });

    lastIdentifiedRef.current = identityKey;
  }, [session?.user, company?.companySlug, company?.companyName]);

  return null;
}
